var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereum({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_400",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29039",
    "data-name": "Group 29039",
    transform: "translate(-4191 4899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4191, -4899)",
    filter: "url(#Ellipse_400)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_400-2",
    "data-name": "Ellipse 400",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-ethereum",
    transform: "translate(4204 -4886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50731",
    "data-name": "Path 50731",
    d: "M11,20.894,23.023,2,35.046,20.894l-12.023,6.87Z",
    fill: "#9fa8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50732",
    "data-name": "Path 50732",
    d: "M25,2,37.023,20.894,25,27.764Z",
    transform: "translate(-1.977)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50733",
    "data-name": "Path 50733",
    d: "M11,27l12.023,6.87L35.046,27,23.023,43.317Z",
    transform: "translate(0 -3.53)",
    fill: "#9fa8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50734",
    "data-name": "Path 50734",
    d: "M23.023,32.6l12.023-6.87L23.023,42.046ZM11,23.153,23.023,18l12.023,5.153-12.023,6.87Z",
    transform: "translate(0 -2.259)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50735",
    "data-name": "Path 50735",
    d: "M25,18l12.023,5.153L25,30.023Z",
    transform: "translate(-1.977 -2.259)",
    fill: "#5c6bc0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.4dfd312a37832b93e4c22ede573071e3.svg";
export { ForwardRef as ReactComponent };